{
  "#APP_OVERVIEW": {
    "ALL_APPLICATIONS": "All Applications",
    "MY_APPLICATIONS": "My Applications",
    "FAVORITES": "Favorites",
    "SEARCH": "Search all applications...",
    "GRID": "Grid View",
    "LIST": "List View"
  }
}
